import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default, { useState, useRef, useMemo, useEffect } from 'react';
import { Manager, Reference } from 'react-popper';
import './Tooltip.scss.js';
import { extractTextFromHTML } from '../../../utils/helpers.js';
import { renderToStaticMarkup } from 'react-dom/server';
import TooltipContent from './TooltipContent.js';

var Tooltip = function Tooltip(_a) {
  var children = _a.children,
      _a$isVisible = _a.isVisible,
      isVisible = _a$isVisible === void 0 ? true : _a$isVisible,
      _a$background = _a.background,
      background = _a$background === void 0 ? 'white' : _a$background,
      _a$openDelay = _a.openDelay,
      openDelay = _a$openDelay === void 0 ? 0 : _a$openDelay,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      props = __rest(_a, ["children", "isVisible", "background", "openDelay", "className"]);

  var _children = _slicedToArray(children, 2),
      content = _children[0],
      contentTooltip = _children[1];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var timeoutId = useRef();
  var text = useMemo(function () {
    try {
      // @ts-ignore
      return extractTextFromHTML(renderToStaticMarkup(contentTooltip));
    } catch (_a) {
      return '';
    }
  }, [contentTooltip]);

  var onMouseEnter = function onMouseEnter() {
    timeoutId.current && clearTimeout(timeoutId.current);
    timeoutId.current = setTimeout(function () {
      setVisible(true);
    }, openDelay);
  };

  var onMouseLeave = function onMouseLeave() {
    timeoutId.current && clearTimeout(timeoutId.current);
    setVisible(false);
  };

  useEffect(function () {
    return function () {
      timeoutId.current && clearTimeout(timeoutId.current);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(Manager, {
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "rf-tooltip",
    className: "rf-tooltip rf-tooltip--".concat(background, " ").concat(className),
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement(Reference, {
    "data-v-6e52f9c7": ""
  }, function (referenceProps) {
    return /*#__PURE__*/React__default.createElement("div", _extends({
      className: "rf-tooltip__reference"
    }, referenceProps, {
      "data-v-6e52f9c7": ""
    }), content);
  }), visible && isVisible && text.length > 0 && /*#__PURE__*/React__default.createElement(TooltipContent, _extends({
    background: background
  }, props, {
    "data-v-6e52f9c7": ""
  }), contentTooltip)));
};

export { Tooltip as default };
